import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
/**
 * @param streamState
 * @param action
 */ export const handleInsertItemsAtOffsetAndSetCursorAction = (streamState, action)=>{
    const newTotal = streamState.total !== undefined ? streamState.total + action.items.length : undefined;
    // Prepend - optimisation concat faster than slice and spread
    if (action.offset === 0) {
        return _object_spread_props(_object_spread({}, streamState), {
            cursor: action.newCursor || streamState.cursor,
            items: action.items.concat(streamState.items || []),
            total: newTotal
        });
    }
    // Append - optimisation concat faster than slice and spread
    if (action.offset === streamState.items.length) {
        return _object_spread_props(_object_spread({}, streamState), {
            cursor: action.newCursor || streamState.cursor,
            items: (streamState.items || []).concat(action.items),
            total: newTotal
        });
    }
    // Inject
    const current = streamState.items || [];
    const newItems = [
        ...current.slice(0, action.offset),
        ...action.items,
        ...current.slice(action.offset)
    ];
    return _object_spread_props(_object_spread({}, streamState), {
        cursor: action.newCursor || streamState.cursor,
        items: newItems,
        total: newTotal
    });
};

//# sourceMappingURL=actionHandlers.js.map